import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-blue-950 px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-6" data-id="element-96" data-mp="28u4ncn43lelf">
      <p className="text-[13px] font-extrabold uppercase tracking-[0.08em] text-teal-300 md:text-[15px]" data-id="element-97" data-mp="28vza86yxjgs5">
        Complete Postoperative Knee Rehabilitation System™
      </p>
      <h1 className="mt-1.5 text-[24px] font-extrabold uppercase leading-[1.08] tracking-[-0.3px] text-white md:text-[34px]" data-id="element-98" data-mp="30kixc88zq6rt">
        The complete postoperative knee rehabilitation system for{' '}
        <span className="text-teal-300" data-id="element-99" data-mp="2rr5yyqs5qcyc">physical therapy professionals</span>
      </h1>
      <p className="mx-auto mt-3 max-w-[580px] text-[14px] leading-[1.45] text-white md:text-[16px]" data-id="element-100" data-mp="3fh09v2sx1rfy">
        Procedure-specific protocols, step-by-step exercises, functional progressions, and assessment tools — organized in
        one collection.
      </p>
      <p className="mx-auto mt-2.5 max-w-[560px] text-[13px] font-extrabold uppercase leading-tight text-amber-400 md:text-[15px]" data-id="element-101" data-mp="2begla15ss3zo">
        Different surgeries. Different rehabilitation needs. One complete professional system.
      </p>

      <div className="mx-auto mt-3 max-w-[340px]" data-id="element-102" data-mp="2kd213ojvx4wr">
        <ProductImage data-id="element-103" data-mp="2z39azfvttflu" />
      </div>

      <h2 className="mx-auto mt-2 max-w-[520px] text-[16px] font-extrabold uppercase leading-snug text-white md:text-[19px]" data-id="element-104" data-mp="2z26k37yi7d5x">
        Complete Postoperative Knee Rehabilitation System™
      </h2>
      <p className="mt-1 text-[13px] font-extrabold uppercase leading-tight text-teal-300 md:text-[15px]" data-id="element-105" data-mp="3834mxmx7hemx">
        7 Advanced Clinical Volumes + 5 FREE Professional Bonuses
      </p>

      <div className="mt-3.5" data-id="element-106" data-mp="1dpd8ma3xm6l5">
        <CtaButton mode="scroll" data-id="element-107" data-mp="1dqokyybg0mnv">Yes! I want the complete knee rehabilitation system!</CtaButton>
      </div>
      <p className="mx-auto mt-3 max-w-[440px] text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-108" data-mp="18swi5999fg4w">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-109" data-mp="3dth2r9ubdx74" />
            7-day money-back guarantee •{' '}
          </>}
        7 volumes + 5 FREE bonuses
      </p>
    </header>;
}